import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('checklistItem', 'checklistItems');

const customActions = {
  async LOAD_checklistItems({ commit, rootGetters }, id) {
    const data = await odata.o(rootGetters)
      .get('checklistItems')
      .query({ $filter: `checklistId eq ${id} AND IsDeleted eq false` });
    commit('SET_checklistItems', data);
    return data;
  },
};

export default { ...actions, ...customActions };
